import React from "react";
import { Phone, ShieldCheck } from "lucide-react";

import Modal from "../common/Modal";
import Input from "../common/Input";

function PhoneNumberModal({ form, setForm, creating, onClose, onSubmit }) {
  return (
  <Modal
    title="Connect phone number"
    description="Add a WhatsApp phone number to this account."
    icon={Phone}
    onClose={onClose}
    onSubmit={onSubmit}
    submitting={creating}
    submitText="Connect phone"
  >
    <div className="space-y-5">
      <div>
        <p className="mb-3 text-[10px] font-semibold uppercase tracking-[0.12em] text-primary dark:text-dark-primary">
          Phone information
        </p>

        <div className="grid gap-4 md:grid-cols-2">
          <Input
            label="Display name"
            name="display_name"
            placeholder="Auto Appy"
            icon={Phone}
            value={form.display_name}
            onChange={(event) =>
              setForm((previous) => ({
                ...previous,
                display_name: event.target.value,
              }))
            }
            disabled={creating}
          />

          <Input
            label="Verified name"
            name="verified_name"
            placeholder="Auto Appy"
            icon={ShieldCheck}
            value={form.verified_name}
            onChange={(event) =>
              setForm((previous) => ({
                ...previous,
                verified_name: event.target.value,
              }))
            }
            disabled={creating}
          />

          <Input
            label="Phone number"
            name="phone_number"
            placeholder="+919111111111"
            icon={Phone}
            value={form.phone_number}
            onChange={(event) =>
              setForm((previous) => ({
                ...previous,
                phone_number: event.target.value,
              }))
            }
            disabled={creating}
          />

          <Input
            label="Meta Phone Number ID"
            name="phone_number_id"
            placeholder="123456789012345"
            icon={ShieldCheck}
            value={form.phone_number_id}
            onChange={(event) =>
              setForm((previous) => ({
                ...previous,
                phone_number_id: event.target.value,
              }))
            }
            disabled={creating}
          />
        </div>
      </div>
      <div className="flex items-start gap-3 rounded-xl border border-theme-200 bg-theme-50 px-3 py-3 dark:border-dark-border dark:bg-dark-soft-blue">
        <ShieldCheck size={16} className="mt-0.5 shrink-0 text-primary dark:text-dark-primary"/>

        <div>
          <p className="text-[10px] font-semibold text-primary dark:text-dark-primary">
            Phone number connection
          </p>

          <p className="mt-0.5 text-[10px] leading-5 text-text-secondary dark:text-dark-text-secondary">
            Make sure the Meta Phone Number ID belongs to the selected
            WhatsApp Business account.
          </p>
        </div>
      </div>
    </div>
  </Modal>
);
}


export default PhoneNumberModal;
